import React, { Component, Fragment } from 'react';
import './App.css';
import Login from './auth/login/Login';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import MainContainer from './main/MainContainer';
import ResetPassword from './auth/reset-password/ResetPassword';
import { connect } from 'react-redux';
import { getAuthentication } from './auth/login/redux/selectors';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastCloseButton } from './shared/toast/ToastCloseButton';

toast.configure();

class App extends Component {
    render() {
        return (
            <Fragment>
                <Switch>
                    <Route exact path="/login" component={Login} />
                    <Route
                        exact
                        path="/reset-password"
                        component={ResetPassword}
                    />
                    <Route
                        path="/"
                        render={() =>
                            this.props.authentication.authenticated ? (
                                <MainContainer />
                            ) : (
                                <Redirect to="/login" />
                            )
                        }
                    />
                </Switch>

                <ToastContainer
                    position="bottom-right"
                    closeButton={
                        <ToastCloseButton className={'close-button'} />
                    }
                    autoClose={8000}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    const authentication = getAuthentication(state);

    return { authentication };
};

export default withRouter(connect(mapStateToProps, null)(App));
